module.exports = __webpack_public_path__ + "static/media/upp_flo_blo_cou.3460af70.png";